import { ClientGroupCode } from '@domgen/dgx-fe-common';
import { GroupMarketingPreferencesFormField } from '../../models/group-marketing-preferences/group-marketing-preferences-form-field.enum';
import { GroupMarketingPreferencesFormValue } from '../../models/group-marketing-preferences/group-marketing-preferences-form-value.type';
import { mockGroupMarketingPreferenceFormValue } from '../group-marketing-preference/group-marketing-preference-form-value.mock';

export const mockGroupMarketingPreferencesFormValue: GroupMarketingPreferencesFormValue =
  {
    [GroupMarketingPreferencesFormField.GroupMarketingConsent]: true,
    [GroupMarketingPreferencesFormField.GroupMarketingPreferences]: {
      [ClientGroupCode.Beko]: mockGroupMarketingPreferenceFormValue,
    },
  };
